<div class="scroll-wrapper">
    <div>
        <ng-content></ng-content>
    </div>

    <div class="custom-scrollbar-track" [ngClass.xs]="scrollbarClass">
        <div class="custom-scrollbar-thumb" [ngClass.xs]="scrollbarClass"></div>
    </div>
</div>
